module.exports = __webpack_public_path__ + "static/sacoches3-0570e859cc6f62c7a9862a859aad372a.jpg";